export default "__VITE_ASSET__38b2eb41__"